import {
    STORE_REPLACE_EXTERNAL_CARDS,
    STORE_RESET_EXTERNAL_CARDS,
} from '@perpay-web/fintech/constants/actionTypes';

const initialState = {};

const cardReducer = (state = initialState, action = undefined) => {
    const { type, payload } = action;

    switch (type) {
        case STORE_REPLACE_EXTERNAL_CARDS:
            return { ...payload };
        case STORE_RESET_EXTERNAL_CARDS:
            return {};
        default:
            return state;
    }
};

export default cardReducer;
